import '@ali/aps-dev/dist/css/aps.css';
import React, { Component } from 'react';
import { Grid, RadioGroup } from '@ali/aps-dev';
import './screen.scss';

const Row = Grid.Row;
class CheckItem extends Component {
  render() {
    return (
      <Row>
        <label className="list-label">{this.props.labelTag}:</label>
        <ul className="checks-wraper">
          {
            this.props.isPc
              ? <RadioGroup
                items={this.props.items}
                onChange={this.props.handlerChangeCheck}
                value={this.props.label}></RadioGroup>
              : <RadioGroup
                items={this.props.items}
                onChange={this.props.handlerChangeCheck}
                value={this.props.label}
                type="button"></RadioGroup>
          }
        </ul>
      </Row>
    );
  }
}
export default CheckItem;


// WEBPACK FOOTER //
// ./src/components/Screen/CheckItem.js